import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy redirect: /staff → /desa/:slug/dashboard
export const Route = createFileRoute('/staff')({
  beforeLoad: async () => {
    try {
      const res = await fetch('/api/users/me', { credentials: 'include' })
      if (!res.ok) throw new Error('not authenticated')
      const user = await res.json()
      if (user?.desa?.slug) {
        throw redirect({ to: `/desa/${user.desa.slug}/dashboard` as any })
      }
    } catch (e) {
      if ((e as any)?.to) throw e
    }
    throw redirect({ to: '/login' })
  },
  component: () => null,
})
